export const openTasksPath = "/tasks?active=open";
export const newTasksPath = "/task/new";
export const myTasksPath = "/tasks?active=my";
